export const integrationsKeys = {
  all: ['integrations'] as const,
  accounts: (accountId: string, provider?: string) =>
    [...integrationsKeys.all, 'accounts', { accountId, provider }] as const,
}

export const cepIntegrationsKeys = {
  listCepIntegrationTemplates: () => ['listCepIntegrationTemplates'] as const,
  listAccountCepIntegrations: (accountId: string) =>
    ['listAccountCepIntegrations', { accountId }] as const,
  getIntegrationById: (integrationId: string) =>
    ['getIntegrationByIntegrationId', { integrationId }] as const,
}
